import { MOCK_ALL_APIS } from "@/constants"
import { TrackEvent } from "./trackEvent.interface"
import { trackEvent } from "./trackEvent"
import { trackEventMock } from "./trackEvent.mock"

const resolvedAction: TrackEvent = MOCK_ALL_APIS ? trackEventMock : trackEvent
export { resolvedAction as trackEvent }
